"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributes = void 0;
var get_attributes_js_1 = require("./get-attributes/get-attributes.js");
Object.defineProperty(exports, "getAttributes", { enumerable: true, get: function () { return get_attributes_js_1.getAttributes; } });
